import { gql } from '@apollo/client';

export const ADD_PHOTOS_TO_FRAMEWORK_ANSWER = gql`
  mutation addPhotosToFrameworkAnswer($inputs: [CreatePhotoFileInput!]!) {
    addPhotosToFrameworkAnswer(inputs: $inputs) {
      id
    }
  }
`;
